import UserService from "@/services/api/user";
import type { User } from "@/types/user";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface UserState {
  users: User[];
  setting: any[];
  userDetails: any[];
  workStationList: any[];
  globalSetting: any[];
  isFetching: boolean;
}

const name = "user";

const initialState: UserState = {
  users: [],
  setting: [],
  userDetails: [],
  workStationList: [],
  globalSetting: [],
  isFetching: false,
};

// Async thunk
export const getUsersSetting = createAsyncThunk(
  "user/getUsersSetting",
  async (_, { rejectWithValue }) => {
    // try {
    //   const response = await UserService.getUsersSetting();
    //   return [response.data.data];
    // } catch (err) {
    //   return rejectWithValue(err);
    // }
  }
);
export const getUserGlobalSetting = createAsyncThunk(
  "user/getUserGlobalSetting",
  async (_, { rejectWithValue }) => {
    try {
      const response = await UserService.getUserGlobalSetting();
      return [response.data.data];
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const checkout = createAsyncThunk(
  "user/checkout",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await UserService.checkout(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const Checkin = createAsyncThunk(
  "user/Checkin",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await UserService.Checkin(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const getWorkStation = createAsyncThunk(
  "user/WorkStation",
  async (_, { rejectWithValue }) => {
    try {
      const response = await UserService.getWorkStations();
      return [response.data.data];
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const getUserById = createAsyncThunk(
  "user/user",
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await UserService.getUserById(id);
      return [response.data.data];
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
const userSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUsersSetting.fulfilled, (state, action) => {
      state.setting = action.payload;
    });
    builder.addCase(getUsersSetting.pending, (state) => {
      state.isFetching = true;
    });
    builder.addCase(getUsersSetting.rejected, (state) => {
      state.isFetching = false;
    });
    builder.addCase(getUserGlobalSetting.fulfilled, (state, action) => {
      state.globalSetting = action.payload;
    });
    builder.addCase(getUserGlobalSetting.pending, (state) => {
      state.isFetching = true;
    });
    builder.addCase(getUserGlobalSetting.rejected, (state) => {
      state.isFetching = false;
    });
    builder.addCase(getWorkStation.fulfilled, (state, action) => {
      state.workStationList = action.payload;
    });
    builder.addCase(getWorkStation.pending, (state) => {
      state.isFetching = true;
    });
    builder.addCase(getWorkStation.rejected, (state) => {
      state.isFetching = false;
    });
    builder.addCase(getUserById.fulfilled, (state, action) => {
      state.userDetails = action.payload;
    });
    builder.addCase(getUserById.pending, (state) => {
      state.isFetching = true;
    });
    builder.addCase(getUserById.rejected, (state) => {
      state.isFetching = false;
    });
  },
});
export default userSlice.reducer;
